import { gql } from "@apollo/client";

export const CREATE_BIZ_CONTACT = gql`
  mutation createBizContact($input: createBizContactInput) {
    createBizContact(input: $input) {
      Id
      orgId
      name
      type
      industry
      email
      alternateEmail
      primaryName
      primaryContact
      secondaryName
      secondaryContact
      products
      location
      website
      PAN
      GST
      TAN
      TIN
      status
      createdAt
    }
  }
`;
















